import React, { ChangeEventHandler } from 'react'

import { useTranslation } from 'react-i18next'

import { ReactComponent as Warning } from 'assets/images/icons/Warning.svg'

import './CustomInput.scss'
import { getClassNameForLanguage } from 'utils/common'

interface ICustomInput {
    onChange?: ChangeEventHandler<HTMLInputElement> | undefined
    handleBlur?: (e: React.FocusEvent<HTMLInputElement>) => void
    value: string | number
    name: string
    type: string
    placeholder?: string
    touched?: boolean
    error?: string
    className?: string
    disabled?: boolean
    label?: string
    readOnly?: boolean
    pattern?: string
    withIcon?: boolean
    max?: number
    isHideErrorMessage?: boolean
}

const CustomInput = ({
    value,
    name,
    placeholder,
    type,
    error,
    touched,
    onChange,
    handleBlur,
    className,
    disabled,
    label,
    readOnly,
    pattern,
    withIcon,
    max,
    isHideErrorMessage = false,
}: ICustomInput): React.ReactElement => {
    const { t, i18n } = useTranslation()

    return (
        <div
            className={`custom-input__wrapper
                ${getClassNameForLanguage({
                    i18n,
                    uk: 'uk-regular',
                    eng: 'eng-regular',
                })}`}
        >
            {label ? (
                <div
                    className={`custom-label
                    ${getClassNameForLanguage({
                        i18n,
                        uk: 'uk-bold',
                        eng: 'eng-bold',
                    })}`}
                >
                    {label}
                </div>
            ) : null}
            <input
                type={type}
                value={value}
                name={name}
                placeholder={placeholder}
                onChange={onChange}
                className={`custom-input ${getClassNameForLanguage({
                    i18n,
                    uk: 'uk-regular',
                    eng: 'eng-regular',
                })} ${touched && error && 'custom-input__error'} ${className}`}
                autoComplete='off'
                disabled={disabled}
                readOnly={readOnly}
                pattern={pattern}
                onBlur={handleBlur}
                max={max}
                maxLength={max}
            />
            {touched && error && !isHideErrorMessage && (
                <p
                    className={`custom-input__error-message
                    ${getClassNameForLanguage({
                        i18n,
                        uk: 'uk-regular',
                        eng: 'eng-regular',
                    })}`}
                >
                    {withIcon && <Warning />}
                    {t(error)}
                </p>
            )}
        </div>
    )
}

CustomInput.defaultProps = {
    placeholder: '',
    className: undefined,
    disabled: false,
}

export default CustomInput
